// extracted by mini-css-extract-plugin
module.exports = {"sticky-footer":"styles_sticky-footer__1RHk2","placeHolderShimmer":"styles_placeHolderShimmer__1_rHH","shimmer":"styles_shimmer__2cLM_"};